const mutations = {
  setControladores(state, controladores) {
    state.controladores = controladores;
  },
  setControladoreSelecionado(state, controlador) {
    window.sessionStorage.setItem('controladorTrade', JSON.stringify(controlador));
    state.controladoreSelecionado = controlador;
  },
  desmarcaSelecao(state) {
    window.sessionStorage.removeItem('controladorTrade');
    state.controladoreSelecionado = null;
  },
};

const actions = {
  carregarControladores({ commit }, resource) {
    return new Promise((resolve, reject) => {
      resource().then((response) => {
        const controladores = response.data || [];
        const titulares = controladores.filter(c => c.ehTitular);
        commit('setControladores', controladores);
        commit('setControladoreSelecionado', titulares[0] || controladores[0] || {});
        resolve();
      }).catch(reject);
    });
  },
  setControladoreSelecionado({ commit }, controlador) {
    commit('setControladoreSelecionado', controlador);
  },
  desmarcaSelecao({ commit }) {
    commit('desmarcaSelecao');
  },
};

const getters = {
  getControladores(state) {
    return state.controladores;
  },
  getControladoreSelecionado(state) {
    return state.controladoreSelecionado;
  },
};

const state = {
  controladores: [],
  controladoreSelecionado: {},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/vuex/modules/controlador.js